<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h6>SIP аккануты</h6>
      </div>
      <div class="card-body">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>SIP</th>
            <th>Пароль</th>
            <!--            <th>Исходящий номер</th>-->
            <th>Вн. номер</th>
            <th>Пользователь</th>
            <!--            <th>Смена</th>-->
            <th>Группа</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="acc in accounts">
            <tr>
              <td class="account_td" colspan="10">{{ acc.login }} ({{ acc.ats_num }}) <strong>{{
                  acc.project_name
                }}</strong></td>
            </tr>
            <tr v-for="(record, i) in records[acc.id]">
              <td>{{ i + 1 }}</td>
              <td>{{ record.sip_login }}</td>
              <td><input @change="updateRecord(record.id, record)" type="text" v-model="record.sip_password"
                         class="form-control">
              </td>
              <!--              <td>{{ record.outline_number }}</td>-->
              <td>{{ record.extension }}</td>
              <td>
                <div>
                  <multiselect
                    @input="updateRecord(record.id)"
                    v-model="selectedManagers[record.id]"
                    :options="managers"
                    track-by="name"
                    label="name"
                    noResult="Пользователь не найден"
                    :disabled="disabled"
                    :show-labels="false"
                    placeholder="Выберите пользователя"
                    :multiple="false">
                  </multiselect>
                </div>
              </td>
              <td v-if="false">
                <multiselect
                  @input="updateRecord(record.id)"
                  v-model="selectedShifts[record.id]"
                  :options="shifts"
                  track-by="title"
                  label="title"
                  noResult="Смена не найдена"
                  :disabled="disabled"
                  :show-labels="false"
                  placeholder="Выберите смену"
                  :multiple="true">
                </multiselect>
              </td>
              <td>
                <!--                  @input="updateRecord(record.id)"-->
                <!--                  track-by="title"-->
                <multiselect
                  @input="updateRecord(record.id)"
                  v-model="selectedGroups[record.id]"
                  :options="groups"
                  track-by="title"
                  label="title"
                  noResult="Группа не найдена"
                  :disabled="disabled"
                  :custom-label="customLabel"
                  placeholder="Выберите группу"
                  select-label="Выбрать"
                  deselect-label="Убрать группу"
                  :multiple="true">
                  <template #option="props">
                    {{ customLabel(props.option) }}
                    <!--                    {{ props.option.title }}-->
                    <!--                    (-->
                    <!--                    <template v-if="(props.option?.data?.projects ?? []).length">-->
                    <!--                      <span-->
                    <!--                        v-for="(p, i) in props.option.data.projects">{{ i !== 0 ? ', ' : '' }}{{-->
                    <!--                          $AllProjects[p]?.title-->
                    <!--                        }}</span>-->
                    <!--                    </template>-->
                    <!--                    <template v-else>-->
                    <!--                      <span>все проекты</span>-->
                    <!--                    </template>-->
                    <!--                    )-->
                    <!--                    {{ props.option.time_shift.start }} - {{ props.option.time_shift.end }}-->
                  </template>
                </multiselect>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Multiselect from 'vue-multiselect'

export default {
  title: 'Sip',
  components: {
    Multiselect,
  },
  data() {
    return {
      records: {},
      accounts: {},
      managers: [],
      shifts: [],
      groups: [],
      selectedManagers: {},
      selectedShifts: {},
      selectedGroups: {},
      disabled: false,
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    customLabel(option) {
      let title = option.title;
      title += option.data?.projects?.all ? ' - все проекты' : '';
      if (option.data && !option.data?.projects?.all) {
        title += ' - '
        title += Object.keys(option.data.projects).reduce((acc, p, i) => {
          if (i !== 0) acc += ', ';
          acc += this.$AllProjects[p].title;
          return acc;
        }, title)
      }
      // console.log(option, option.title, option.data, title);
      return title;
      // return `${option.title} – ${(option.data?.projects ?? []).length ? option.data.projects.reduce((acc, p, i) => {
      //   if (i !== 0) acc += ', ';
      //   acc += this.$AllProjects[p]?.title;
      //   return acc;
      // }, '') : 'все проекты'}`;
    },
    async getRecords() {
      const {data} = await api.index('/telephony/sip');
      if (data.success) {
        this.managers = data.managers;
        this.shifts = data.shifts;
        this.groups = data.groups;
        const selectedManagers = {};
        const selectedGroups = {};
        this.records = data.sips.reduce((acc, r) => {
          if (!acc[r.acc_id]) acc[r.acc_id] = [];
          acc[r.acc_id].push(r);
          if (r.user_id) {
            const user = data.managers.find((m) => m.id === r.user_id);
            selectedManagers[r.id] = user;
          }
          // selectedGroups[r.id] = [];
          return acc;
        }, {});
        this.selectedManagers = selectedManagers;

        const selectedShifts = {};
        data.selectedShifts.forEach((s) => {
          if (s.shift_id) {
            const shift = data.shifts.find((r) => r.id === s.shift_id);
            if (!selectedShifts[s.sip_id]) {
              selectedShifts[s.sip_id] = [];
            }
            selectedShifts[s.sip_id].push(shift);
          }
          if (s.manager_group_id) {
            if (!selectedGroups[s.sip_id]) {
              selectedGroups[s.sip_id] = [];
            }
            const group = data.groups.find((g) => g.id === s.manager_group_id);
            selectedGroups[s.sip_id].push(group);
          }
        })
        this.selectedShifts = selectedShifts;
        this.selectedGroups = selectedGroups;

        this.accounts = data.accounts.reduce((acc, a) => {
          acc[a.id] = a;
          return acc;
        }, {})
      } else {
        toastr['warning'](data.message || 'Ошибка сервера', 'Ошибка!');
      }
    },
    async updateRecord(id, record = null) {
      if (this.disabled) return;
      this.disabled = true;
      console.log(record);
      const {data} = await api.post('/telephony/sip', {
        recordId: id,
        record: record,
        selectedManager: this.selectedManagers[id],
        selectedShifts: this.selectedShifts[id],
        selectedGroups: this.selectedGroups[id],
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено', 'Успешно!');
      } else {
        toastr['warning'](data.message || 'Ошибка сервера', 'Ошибка!');
      }
      this.disabled = false;
    }
  }
}
</script>

<style scoped>
.account_td {
  color: white;
  background-color: #5BBFDE;
}
</style>
